"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var angular = require("angular");
var ProcessDetailsModalService = (function () {
    function ProcessDetailsModalService($compile, $rootScope) {
        var _this = this;
        this.noPropagation = function ($event) {
            $event.stopPropagation();
        };
        this.OpenProcessDetailsModal = function (processData, doFetchByJobQId) {
            if (doFetchByJobQId === void 0) { doFetchByJobQId = false; }
            var scope = _this.$rootScope;
            scope.processData = processData;
            scope.doFetchByJobQId = doFetchByJobQId;
            _this.$currentModal = _this.$compile('<process-details-popup process-data="processData" do-fetch-by-job-q-id="doFetchByJobQId"></process-details-popup>')(_this.$rootScope.$new());
            _this.$containerElement.append(_this.$currentModal);
            _this.addOutsideClickEventListener();
        };
        this.CloseProcessDetailsModal = function () {
            if (_this.$currentModal == null) {
                return;
            }
            _this.removeOutsideClickEventListener();
            _this.$containerElement.empty();
            _this.$currentModal = null;
        };
        this.addOutsideClickEventListener = function () {
            _this.$containerElement[0].addEventListener("click", _this.CloseProcessDetailsModal);
        };
        this.removeOutsideClickEventListener = function () {
            _this.$containerElement[0].removeEventListener("click", _this.CloseProcessDetailsModal);
        };
        this.$compile = $compile;
        this.$rootScope = $rootScope;
        this.$containerElement = angular.element(document.getElementById("PopupContainer"));
        this.$containerElement[0].addEventListener("click", this.noPropagation);
    }
    return ProcessDetailsModalService;
}());
ProcessDetailsModalService.$inject = ['$compile', '$rootScope'];
exports.ProcessDetailsModalService = ProcessDetailsModalService;
//# sourceMappingURL=processDetailsModalService.js.map



// WEBPACK FOOTER //
// ./src/services/models/processDetailsModalService.js